import { render, staticRenderFns } from "./deleteHousekeepingResource.vue?vue&type=template&id=970d966a"
import script from "./deleteHousekeepingResource.vue?vue&type=script&lang=js"
export * from "./deleteHousekeepingResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports